import React from "react";
import { useLocation } from "react-router-dom";
import BEEEModuleSubtopic from "../BEEEModuleSubtopic";

const SemiconductorDevicesAndApplications = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <BEEEModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Semiconductor Devices and Applications"
      videos={[
        "https://www.youtube.com/embed/USrY0JspDEg",
        "https://www.youtube.com/embed/_vKeaPHXF9U",
        "https://www.youtube.com/embed/JdL3DnnFHXw",
        "https://www.youtube.com/embed/-VwPSDQmdjM",
        "https://www.youtube.com/embed/l9LBIy9Ioxo",
        "https://www.youtube.com/embed/rPb0p7N1O00",
        "https://www.youtube.com/embed/kiiA6WTCQn0?list=PLwjK_iyK4LLDBB1E9MFbxGCEnmMMOAXOH",
        "https://www.youtube.com/embed/6OMEF5MkU7k",
        "https://www.youtube.com/embed/Ll0IOk_Ltfc",
        "https://www.youtube.com/embed/AspBbh_jOuk"
      ]}
      takeaways={[
        { text: "Learn characteristics of PN junction diode, Zener diode, BJT, MOSFET." },
        { text: "Applications are also be asked." },
        { text: "Theory questions are asked." }
      ]}
      questions={[
        "Explain the operation of a single phase diode bridge rectifier constructed using PN junction diode. Also draw the input and output voltage waveforms.",
        "Explain the construction and working of BJT with the help of neat schematic and draw its output characteristics in CE configuration.",
        "Explain the constructions and working of a PN-junction diode. Also, explain the VI characteristics.",
        "Explain detail about the formation different biasing conditions and characteristics of PN junction diode.",
        "Write the applications of Zener diode.",
        "Explain the operation of P channel enhancement MOSFET and also draw its characteristics.",
        "List the differences between P-N junction and Zener diodes. Sketch their V-I characteristic and explain their respective behaviour."
      ]}
      exampleVideos={[]}
    />
  );
}

export default SemiconductorDevicesAndApplications;
